export const TEXT_KEYS = {
    REDEEM_CODE_BUTTON_TEXT: 'redeem-code__button'
};

export const CODE_URL_PARAMETER: string = 'code';
